const regions = {
  ALL: [
    {code: 'LATAM', name: 'LATAM'},
    {code: 'NA', name: 'NA'},
    {code: 'APAC', name: 'APAC'},
    {code: 'EMEA', name: 'EMEA'}
  ],
  VIBER: [
    {code: 'LATAM', name: 'LATAM'},
    {code: 'APA', name: 'APA'},
    {code: 'APAC', name: 'APAC'},
    {code: 'EMEA', name: 'EMEA'},
    {code: 'nz', name: 'New Zealand'},
    {code: 'dk', name: 'Denmark'},
    {code: 'md', name: 'Moldova'},
    {code: 'no', name: 'Norway'},
    {code: 'np', name: 'Nepal'},
    {code: 'ma', name: 'Morocco'},
    {code: 'us', name: 'United States'},
    {code: 'et', name: 'Ethiopia'},
    {code: 'ly', name: 'Libya'},
    {code: 'se', name: 'Sweden'},
    {code: 'si', name: 'Slovenia'},
    {code: 'rs', name: 'Serbia'},
    {code: 'gr', name: 'Greece'},
    {code: 'jp', name: 'Japan'},
    {code: 'ph', name: 'Philippines'},
    {code: 'be', name: 'Belgium'},
    {code: 'ba', name: 'Bosnia & Herzegovina'},
    {code: 'ca', name: 'Canada'},
    {code: 'ua', name: 'Ukraine'},
    {code: 'dz', name: 'Algeria'},
    {code: 'uk', name: 'United Kingdom'},
    {code: 'cz', name: 'Czech Republic'},
    {code: 'hr', name: 'Croatia'},
    {code: 'bg', name: 'Bulgaria'},
    {code: 'sk', name: 'Slovakia'},
    {code: 'au', name: 'Australia'},
    {code: 'mk', name: 'Macedonia, The Former Yugoslav Republic Of'},
    {code: 'hu', name: 'Hungary'},
    {code: 'by', name: 'Belarus'},
    {code: 'es', name: 'Spain'},
    {code: 'lk', name: 'Sri Lanka'},
    {code: 'fr', name: 'France'},
    {code: 'iq', name: 'Iraq'},
    {code: 'ge', name: 'Georgia'},
    {code: 'ru', name: 'Russia'},
    {code: 'de', name: 'Germany'},
    {code: 'pt', name: 'Portugal'},
    {code: 'vn', name: 'Viet Nam'}
  ]
};

export { regions };
